import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import ValueProposition from "./components/ValueProposition";
import HowItWorks from "./components/HowItWorks";
import TrustSection from "./components/TrustSection";
import CTASection from "./components/CTASection";
import BlogCTASection from "./components/BlogCTASection";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ValueProposition />
        <HowItWorks />
        <TrustSection />
        <BlogCTASection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}